import { GridColDef } from "@mui/x-data-grid";

const segmentColumnDef: GridColDef[] = [
    { field: 'segment_id', headerName: 'ID', width: 200 },
    { field: 'agency_name', headerName: 'Agency Name', width: 200 },
    { field: 'name', headerName: 'Segment Name', width: 200 },
    { field: 'description', headerName: 'Description', width: 200 },
    { field: 'is_active', headerName: 'Status', width: 200 },
    { field: 'client_name', headerName: 'Client', width: 200 },
    { field: 'dpd_bucket', headerName: 'DPD Buckets', width: 200 },
    { field: 'pin_code', headerName: 'Pincodes', width: 200 },
    { field: 'loan_type', headerName: 'Loan Types', width: 200 },
    { field: 'state', headerName: 'States', width: 200 },
    { field: 'district', headerName: 'Districts', width: 200 },
    { field: 'created_date', headerName: 'Created Date', width: 200 },
    { field: 'created_by', headerName: 'Created By', width: 200 },
    { field: 'updated_date', headerName: 'Updated Date', width: 200 },
    { field: 'updated_by', headerName: 'Updated By', width: 200 },
];

export default segmentColumnDef;